<template>
  <div class="mt-20">
    <!-- Type of enquiry; 0 === information, 1 === demo, 2 === sign up, 3 === upgrade plan, 4 === other, 5 === Hail, 6 === org registration -->
    <StickyBtn text="Enquire" title="now" :target="6" />

    <!-- Hero -->
    <Slider
      :slides="slides"
      :controls="true"
      :show-tagline="false"
      :show-gradient="true"
    />

    <div
      class="flex flex-col items-center justify-center w-full px-12 sm:px-16 py-20 sm:py-32 relative overflow-hidden"
    >
      <div class="flex flex-col items-center justify-center md:flex-row w-full">
        <div class="flex justify-center text-center w-full">
          <div
            class="flex flex-col items-start justify-center text-center lg:w-3/5"
          >
            <h2
              class="font-black font-montserrat mx-auto text-5xl text-center text-cw-900"
            >
              One Careers Platform.<br />
              Endless Potential.
            </h2>
            <p class="mb-0 text-lg">
              CareerWise is your direct channel to connect with aspiring
              students, showcasing your organisation's potential and sector's
              exciting career paths. Reach the next generation of talent like
              never before.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- library CW -->
    <div
      class="flex flex-col items-center justify-center w-full px-12 sm:px-16 py-20 md:py-32 bg-cw-50 relative"
    >
      <div
        class="flex flex-col md:flex-row w-full max-w-6xl justify-center items-center"
      >
        <div class="w-full lg:w-5/12">
          <div class="flex flex-col items-start">
            <h2 class="font-montserrat text-cw-900 font-black text-5xl">
              Join the CareerWise Cloud
            </h2>
            <p class="text-truegray-700 mb-12 text-left">
              The CareerWise Cloud presents a unique opportunity to engage with
              tens of thousands of high school students (and their parents)
              across New Zealand with careers related information! Subscribe and
              share your news, events, scholarships, and job opportunities.
            </p>
          </div>
        </div>
        <div class="w-full lg:w-7/12 flex md:pl-24">
          <img
            src="/img/cw-marketing/forBiz_library.png"
            alt="Illustration library"
          />
        </div>
      </div>
    </div>

    <!-- Marketing Stats -->
    <GradientPanel :item="marketingData" />

    <!-- Partner list  -->
    <PartnerList title="Our Contributors" />

    <!-- CTA: For business -->
    <div
      class="flex flex-col items-center justify-center w-full px-0 pt-0 md:p-16"
    >
      <div
        class="flex flex-wrap md:flex-nowrap w-full max-w-6xl rounded-none md:rounded-4xl bg-black px-12 py-24 sm:p-0 text-white relative overflow-hidden"
      >
        <div class="w-full lg:w-3/4 relative sm:p-24 lg:py-24">
          <img
            :style="[{ left: '-30%' }, { bottom: '-30%' }]"
            class="absolute w-full lg:w-10/12 opacity-10 filter brightness-0 invert"
            src="/img/cw-marketing/cw-shapes_dots.svg"
            alt="CW alt shapes"
          />
          <div class="flex flex-col items-start relative">
            <h2 class="font-montserrat font-black text-4xl mb-12">
              Are you a business or education provider that would like to work
              with us?
            </h2>
            <button
              class="m-0 btn btn-cw-alt font-nunito shadow-lg"
              @click="showOrgRegistrationModal"
            >
              Let's talk!
            </button>
          </div>
        </div>
        <div class="hidden lg:flex items-center justify-center w-1/4">
          <img
            class="z-10"
            src="/img/cw-marketing/illu-owl.svg"
            alt="Illustration CW owl"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shared } from '../../../js/mixins/shared.js'
import { EventBus } from '../../../js/plugins/event-bus.js'
import * as loadingAnimation from '../../../shared/components/loading.json'
import PartnerList from '../components/PartnerList.vue'
import CardGroup from '../components/CardGroup.vue'
import StickyBtn from '../components/StickyButton.vue'
import GradientPanel from '../components/GradientPanel.vue'
import Slider from '../components/SliderPanel.vue'

export default {
  components: {
    StickyBtn,
    Slider,
    PartnerList,
    CardGroup,
    GradientPanel,
  },

  mixins: [shared],

  data() {
    return {
      slides: [
        {
          image: '/img/cw-marketing/hero_slider_forBiz_1.png',
          title: 'Deliver careers information to schools across NZ!',
        },
        {
          image: '/img/cw-marketing/hero_slider_forBiz_2.png',
          title: 'Effectively connect with your target audience',
        },
        {
          image: '/img/cw-marketing/hero_slider_forBiz_3.png',
          title: 'Reach thousands of students with your content!',
        },
        {
          image: '/img/cw-marketing/hero_slider_forBiz_4.png',
          title: 'One Platform. Endless Potential.',
          text: 'Transform how students discover their future, how schools support their growth, and how industries find their next breakthrough talent.',
        },
      ],

      currentIndex: 0,
      timer: null,

      marketingData: {
        title: 'Who can be a Cloud Contributor?',
        text: 'Are you an educational institution, employer, or trade association with study and career pathways that should be considered by high school leavers? If so, then there’s no more efficient way to build your talent and/or recruitment pipeline than with CareerWise.',
        buttonText: 'Enquire now',
        image: '/img/cw-marketing/forBiz_industries.png',
        stats: [],
      },

      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,
    }
  },

  methods: {
    showOrgRegistrationModal() {
      EventBus.$emit('showModal', {
        action: 'cw-organisation-registration',
      })
    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700;900&display=swap');

/* Hero slide effects */
.slide-enter {
  transform: translateX(12px);
  opacity: 0;
}

.slide-enter-to {
  transform: translateX(0);
}

.slide-leave {
  transform: translateX(0%);
}

.slide-leave-to {
  transform: translateX(-12px);
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease-in-out;
}
</style>
